<script setup>
import {ref} from "vue";

const props = defineProps({
    previewImageUrl: {
        type: String,
        required: true,
    },
    previewUrl: {
        type: String,
        required: true,
    },
});

const isPreviewLoading = ref(false);
const isPreviewImageBroken = ref(false);

const handlePreviewImageError = () => {
    isPreviewImageBroken.value = true;
};

const handlePreviewImageLoad = () => {
    isPreviewImageBroken.value = false;
};

const showPreview = () => {

    if (isPreviewLoading.value) {
        return;
    }

    isPreviewLoading.value = true;

    const iframe = document.createElement('iframe');
    iframe.id = 'po-portal-layout-iframe';
    iframe.className = 'fixed inset-0 w-full h-full border-0 z-[99999999] hidden';
    iframe.src = props.previewUrl;
    iframe.title = 'Preview';

    document.body.appendChild(iframe);

    // Define message handler
    const handleMessage = (event) => {
        if (event.data?.type === 'po:portal-layout-popup:close') {
            iframe.remove();
            // Remove event listener when popup is closed
            window.removeEventListener('message', handleMessage);
        }
        if (event.data?.type === 'po:portal-layout-popup:loaded') {
            isPreviewLoading.value = false;
            iframe.classList.remove('hidden');
        }
    };

    // Add event listener
    window.addEventListener('message', handleMessage);
}
</script>

<template>
    <div class="group bg-gray-50 h-28 border rounded flex flex-shrink-0 relative cursor-pointer">
        <img
            v-if="!isPreviewImageBroken"
            :src="previewImageUrl + '?t=' + Date.now()"
            alt="Portal layout preview"
            class="absolute inset-0 w-full h-full object-cover"
            @error="handlePreviewImageError"
            @load="handlePreviewImageLoad"
        >
        <img v-else src="/images/portal/portal_layout_preview.png" alt="Portal layout preview" class="absolute inset-0 w-full h-full object-cover">

        <div v-if="isPreviewLoading" class="absolute inset-0 flex items-center justify-center">
            <icon name="spinner" size="24" class="animate-spin"></icon>
        </div>
        <div v-else @click="showPreview" class="invisible group-hover:visible absolute inset-0 flex items-center justify-center">
            <icon name="eye"></icon>
        </div>
    </div>
</template>

